export const dialogProps = {
  modelValue: Boolean,
  title: String,
  width: {
    type: [String, Number],
  },
  top: {
    type: [String, Number],
  },
  showClose: {
    type: Boolean,
    default: false,
  },
  fullscreen: {
    type: Boolean,
    default: false,
  },
  closeOnClickModal: {
    type: Boolean,
    default: true,
  },
  center: {
    type: Boolean,
    default: false,
  },
}
